export default {
      id: "arrowright-white-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#arrowright-white",
      toString: function () {
        return this.url;
      }
    }